import React, { useEffect, useState } from 'react';
import axios from 'axios';
import bridge from '@vkontakte/vk-bridge';
import './App.css';

const App = () => {
    const [user, setUser] = useState(null);
    const [serverData, setServerData] = useState(null);
    const [headerText, setHeaderText] = useState('PixelCRM');
    const [maskedPhone, setMaskedPhone] = useState('');
    const [Phone, setPhone] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showModalLoading, setShowModalLoading] = useState(false);
    const [requestError, setRequestError] = useState(false);
    const [requestError2, setRequestError2] = useState(false);
    const [requestError3, setRequestError3] = useState(false);
    const [requestError4, setRequestError4] = useState(false);
    const [requestError3Text, setRequestError3Text] = useState(false);

    // Инициализация VK Bridge и установка заголовка
    useEffect(() => {
        bridge.send('VKWebAppInit');

        // Извлечение параметра из URL
        const hashParams = new URLSearchParams(window.location.hash.slice(1));
        const redirectSite = hashParams.get('linkURLRedirect');
        if (redirectSite) {
            setHeaderText(`${redirectSite}`);
        }

        // Запрос информации о пользователе через VK Bridge
        bridge
            .send('VKWebAppGetUserInfo')
            .then((data) => {
                setUser(data);
                console.log('User data:', data);
            })
            .catch((error) => console.log('VK Bridge error:', error));
    }, []);

    // Пример запроса к серверу
    const fetchData = async () => {
        try {
            const response = await axios.get('https://your-server-endpoint.com/api/data');
            setServerData(response.data);
            console.log('Server data:', response.data);
        } catch (error) {
            console.error('Axios error:', error);
        }
    };

    const Loader = () => (
        <div className="loader"></div>
    );

  // Функция для запроса номера телефона
  const requestPhoneNumber = () => {
      setShowModalLoading(true);
    bridge
      .send('VKWebAppGetPhoneNumber')
      .then((data) => {
        if (data.phone_number) {
                    // Маскируем номер телефона
                    const masked = maskPhoneNumber(data.phone_number);
                    setRequestError(false);
                    setMaskedPhone(masked);
                    setPhone(data.phone_number);
            setShowModalLoading(false);
            setShowModal(true); // Показываем модальное окно

        } else {
                    // Пользователь отклонил доступ
                    setRequestError(true); // Показываем сообщение об ошибке
            setShowModalLoading(false);

        }
      })
      .catch((error) => {
          // Пользователь отклонил доступ
          setShowModalLoading(false);

          setRequestError(true); // Показываем сообщение об ошибке
          console.error('Error requesting phone number:', error)
      });
  };

    // Маскировка номера телефона (оставляем только первую и последние две цифры)
    const maskPhoneNumber = (phone) => {
        return phone.replace(/.(?=.{4})/g, '*').replace(/^(.{2})/, '$1');
    };

    // Обработка подтверждения номера
    const handleConfirmPhone = () => {
        setShowModal(false); // Закрываем модальное окно
        // Отправляем номер на сервер (пример отправки)
        axios
            .post('https://tghook.ebee.me/vk_webhook.php', {
                updateMessageVKBot:{
                    phone_number: Phone,
                    idUserVK: user?.id
                }
            })
            .then((response) => {
                switch (response.data?.error) {
                    case true:
                        setRequestError3Text(response.data.errorMessage);
                        setRequestError3(true);
                        console.log('Ошибка:', response.data);
                        break;
                    case false:
                        setRequestError4(true);
                        setRequestError3Text(response.data.result);
                        console.log('Нет ошибок:', response.data);
                        break;
                    default:
                        setRequestError3Text(response.data.errorMessage);
                        setRequestError3(true);
                        console.log('Ошибка есть:', response.data);
                }

            })
            .catch((error) => console.error('Error confirming phone:', error));
    };

    // Обработка отклонения номера
    const handleDeclinePhone = () => {
        setShowModal(false);
        setRequestError2(true);
    };

    const WaiteDiv = (<>
        {user ? (
                <div style={styles.userContainer}>
                    {user.photo_200 && (
                        <img src={user.photo_200} alt="User Avatar" style={styles.avatar} />
                    )}
                    <p style={styles.greetingText}>Здравствуй, {user.first_name}! <br />Это бот авторизации в сервисах PixelCRM.</p>
                    <p style={styles.infoText}>
                        Для авторизации, необходимо подтвердить Ваш номер телефона, привязанный к аккаунту. Пожалуйста, подтвердите ваш номер телефона по кнопке ниже.
                    </p>
                    <button onClick={requestPhoneNumber} style={styles.button}>
                        Подтвердить номер
                    </button>
                    {requestError && (
                        <p style={styles.errorText}>
                            Мы не смогли получить ваш номер телефона. Возможно вы запретили его получение. Пожалуйста, попробуйте еще раз.
                        </p>
                    )}

                    {requestError2 && (
                        <p style={styles.errorText}>
                            Пожалуйста, войдите с номером телефона, указанным при регистрации на сайте.
                        </p>
                    )}

                    <p style={{color:"#95a99e"}}>
                        Нажимая "Подтвердить номер", вы соглашаетесь с{' '}
                        <a style={styles.privacyPolicyLink} href={headerText+'/Privacy_policy'} target={"_blank"}>
                            политикой конфиденциальности
                        </a>.
                    </p>
                </div>
            ) : (
                <p style={styles.loadingText}>Загрузка информации о пользователе...</p>
            )}
        </>
    );

    return (
        <div style={styles.container}>
            <h1 style={styles.header}>Авторизация  <br />{headerText}</h1>
            {requestError3 ? <div style={styles.userContainer}><p style={styles.errorText}>
                {requestError3Text}
            </p></div> : requestError4 ? <div style={styles.userContainer}><p style={styles.successText}>{requestError3Text}</p></div> : WaiteDiv}

            {serverData && (
                <div style={styles.serverDataContainer}>
                    <h2>Данные с сервера:</h2>
                    <pre style={styles.serverData}>{JSON.stringify(serverData, null, 2)}</pre>
                </div>
            )}

            {/* Модальное окно для подтверждения номера */}
            {showModal && (
                <div style={styles.modalOverlay}>
                    <div style={styles.modal}>
                        <p>Ваш номер телефона: {maskedPhone}</p>
                        <p>Это нужный номер?</p>
                        <button onClick={handleConfirmPhone} style={styles.button}>
                            Да
                        </button>
                        <button onClick={handleDeclinePhone} style={styles.buttonSecondary}>
                            Нет
                        </button>
                    </div>
                </div>
            )}

            {/* Модальное окно прелоадер */}
            {showModalLoading && (
                <div style={styles.modalOverlay}>
                    <div style={styles.modal}>
                        <p>Загрузка</p>
                        <p>{Loader}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

// Стили для компонента
const styles = {
    container: {
        padding: '20px',
        paddingBottom:0,
        textAlign: 'center',
        fontFamily: 'Arial, sans-serif',
        backgroundColor: '#f0f2f5',
        minHeight: '100vh'
    },
    header: {
        fontSize: '28px',
        color: '#333',
        marginBottom: '20px',
    },
    userContainer: {
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        maxWidth: '400px',
        margin: '0 auto',
    },
    greetingText: {
        fontSize: '18px',
        color: '#333',
        marginBottom: '10px',
    },
    infoText: {
        fontSize: '14px',
        color: '#666',
        margin: '15px 0',
    },
    avatar: {
        borderRadius: '50%',
        width: '100px',
        height: '100px',
        marginBottom: '15px',
    },
    button: {
        backgroundColor: '#4CAF50',
        color: 'white',
        border: 'none',
        padding: '10px 20px',
        fontSize: '16px',
        cursor: 'pointer',
        borderRadius: '5px',
        marginTop: '10px',
    },
    buttonSecondary: {
        backgroundColor: '#f44336',
        color: 'white',
        border: 'none',
        padding: '10px 20px',
        fontSize: '16px',
        cursor: 'pointer',
        borderRadius: '5px',
        marginTop: '10px',
        marginLeft: '10px',
    },
    loadingText: {
        color: '#555',
        fontSize: '16px',
    },
    errorText: {
        color: '#f44336',
        fontSize: '14px',
        marginTop: '15px',
    },
    successText: {
        color: '#4CAF50',
        fontSize: '14px',
        marginTop: '15px',
        fontWeight:"bold"
    },
    serverDataContainer: {
        marginTop: '30px',
        textAlign: 'left',
    },
    serverData: {
        backgroundColor: '#e9ecef',
        padding: '10px',
        borderRadius: '5px',
        overflowX: 'auto',
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    modal: {
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '8px',
        textAlign: 'center',
        width: '300px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
    },
    privacyPolicyLink: {
        color: '#ff958c9e',
        textDecorationLine: 'underline'
    }
};

export default App;
